<template lang="pug">
b-row.mx-0
  transition(name="fade")
    b-card.mx-1.w-100(v-if="dailyDialogue" bg-variant="transparent", border-variant="secondary")
      b-card-body.p-0
        b-card-text.text-warning {{$t('message.important').toUpperCase()}} 
        b-card-text {{ $t('message.dailyDialoguePartialMessage') }}
  b-col(v-if="!confirmationPage.route" cols="12")
    div(:class="{ 'happiness-blocked': isHappinessTabActive && !happinessReady }")
      form-wizard.wizard-vertical.mb-3(
        :color="colors.primary"
        :title="null",
        :subtitle="null",
        layout="horizontal",
        :finish-button-text="$t('message.submit')",
        :back-button-text="$t('message.previous')",
        :next-button-text="$t('message.next')",
        @on-complete="formSubmitted",
        @on-change="handleTabChange",
        ref="myForm"
      )

        // Information
        tab-content(v-if="information_module || showOnlyCustomersOpinions" :title="$t('message.information')" class="mb-2" )
          b-row
            b-col.mb-1.mt-1(cols="12")
                h5.text-primary.mb-0
                  | {{ $t('message.info_daily_dialogue') }}
            b-col.mb-2.mt-2(cols="12")
              // Action Buttom
              b-row
                b-col(v-if="physical_location_in_daily_dialogue" md="4")
                  b-form-group(
                    :label="$t('label.Physical Location')",
                    label-for="v-location",
                    :description="$t('message.where_meeting_held')"
                  )
                    validation-provider(:name="$t('label.Physical Location')", rules="required", v-slot="{ errors }")
                      v-select#v-location(
                        v-model="meeting.physical_location",
                        :options="filteredPhysicalLocations",
                        :selectable="(option) => !option.value.includes('select_value')",
                        label="title"
                      )
                      small(class="text-danger") {{ errors[0] }}
                b-col(md="4" cols="12" class="mt-md-0 mt-2")
                  b-form-group(:label="$t('label.Location')" label-for="v-location", :description="$t('message.where_meeting_held')")
                    validation-provider(:name="$t('label.Location')", rules="required", v-slot="{ errors }")
                      v-select#v-location(
                        v-model="meeting.location",
                        :options="filteredLocations",
                        :selectable="(option) => !option.value.includes('select_value')",
                        label="title"
                      )
                      small(class="text-danger") {{ errors[0] }}
              b-row.mt-2
                b-col(v-if="!showOnlyCustomersOpinions" md="4" cols="12" class="mt-md-0 mt-2")
                  b-button(class="w-100" :class="activeButton === 'communications' ? 'activeClassButton' : 'optionButton'" @click="handleActiveButton('communications')")
                    span {{ $t('message.internalCommunications') }}
                // Exclude customer opinion and barometer survey for client Explora
                // TODO: Change this hardcoded client ID logic to a more generic one
                b-col(v-if="client_id !== '688bc1183c0eff975f0aecb6'" md="4" cols="12" class="mt-md-0 mt-2")
                  b-button(class="w-100" :class="activeButton === 'opinions' || showOnlyCustomersOpinions ? 'activeClassButton' : 'optionButton'", @click="handleActiveButton('opinions')")
                    span {{$t('message.customersOpinion') }}        
            // Communication
            b-col.mb-2.mt-1(cols="12" v-if="activeButton === 'communications'")
              h5.text-primary.mb-0
                | {{ $t('message.communicationsFound') }}: {{ communications.length }}
              b-row(class="mt-2 pb-1 border-bottom-primary")
                b-col(md="5")
                  h6.text-primary      
                    | {{ $t('label.date') }}:
                  span
                    | {{  actualDateToShow }}
                b-col(md="4" class="mt-md-0 mt-2")
                  h6.text-primary       
                    | {{ $t('message.tableHeader.location') }}:
                  b-form-group(label-for="v-location")
                    span
                        |  {{ filteredLocation }}
              // Loader
              div(v-if="isLoading" bg-variant="transparent", border-variant="secondary" style="margin-top: 20rem")
                b-card-body.text-center
                  loading(
                    :active="true" 
                    :is-full-page="false"
                    :color="colors.primary"
                    :opacity="0"
                )
              div(v-else="!isLoading" class="mt-md-0 mt-2")
                b-col(cols="12" v-if="communications.length > 0" class="px-0")
                  b-row(v-for="(communication, index) in communications" :key="index" class="d-flex justify-content-between border-bottom-primary")                   
                    // Title
                    b-col(md="12" class="mb-2 mt-1")
                      h6.text-primary(style="font-weight: bold;")
                          | {{ $t('message.tableHeader.title') }}:
                      span
                        | {{ communication.title }}

                    b-col(md="5" class="mb-1")
                      b-row(class="mr-2")                              
                        // Date from
                        b-col(md="4" class="mb-2")
                          h6.text-primary(style="font-weight: bold;")
                            | {{ $t('message.tableHeader.dateFrom') }}:
                          span
                            | {{ communication.dateFrom }}

                        // Date to    
                        b-col(md="4" class="mb-1")
                          h6.text-primary(style="font-weight: bold;")
                            | {{ $t('message.tableHeader.dateTo') }}:
                          span
                            | {{ communication.dateTo }}
                      // Image
                      b-col(md="12" class="mx-0 px-0" style="margin-bottom: 2rem;")
                        h6.text-primary(style="font-weight: bold;")
                          | {{ $t('message.tableHeader.img') }}:
                        div(v-if="communication.imageKey" @click="openImage(communication.imageKey)" class="image-container")
                          img.img-preview(:src="communication.src" alt="img")
                          span.hover-text
                            | {{ $t('message.tableHeader.fullSize') }}
                        div(v-else class="image-container")
                          img(:src="require('@/assets/images/elements/no-image.jpg')", alt="img", class="img-preview")
                          span.no-image {{ $t('happiness.no_image') }}

                    b-col(md="7" class="mb-2" style="border-left: 1px solid #ccc;")
                      // Detail
                      h6.text-primary(style="font-weight: bold;")
                        | {{ $t('message.tableHeader.detail') }}:
                      div.text-justify
                        p(v-html="communication.detail")

                // No data message
                b-col(v-else cols="12" class="mt-3 p-0")
                  h6.no-data-message
                    | {{ $t('message.no_records') }}

            // Opinions
            b-col.mb-2.mt-2(cols="12" v-else)
              h5.text-primary.mb-0
                | {{ $t('message.customersOpinionsFound') }}: {{ customersOpinions.length }}
              b-row(class="mt-2 pb-1 border-bottom-primary")
                b-col(md="5")
                  h6.text-primary      
                    | {{ $t('label.date') }}:
                  span
                    | {{ sevenDaysBeforeToShow }} - {{ actualDateToShow }}
                b-col(md="4" class="mt-md-0 mt-2")
                  h6.text-primary       
                    | {{ $t('message.tableHeader.location') }}:
                  b-form-group(label-for="v-location")
                    span
                        |  {{ filteredLocation }}
              // Loader
              div(v-if="isLoading" bg-variant="transparent", border-variant="secondary" style="margin-top: 20rem")
                b-card-body.text-center
                  loading(
                    :active="true" 
                    :is-full-page="false"
                    :color="colors.primary"
                    :opacity="0"
                )
              div(v-show="!isLoading" class="mt-md-0 mt-2")
                b-col(cols="12" v-if="customersOpinions.length > 0" class="px-0")
                  b-table(
                      class="mt-2"
                      :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
                      show-empty=""
                      :items="paginatedCustomersOpinions"
                      hover
                      responsive
                      :fields="tableColumns"
                      primary-key="id"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="isSortDirDesc"
                    )
                      template(#cell(location)="data")
                        div {{ data.item.location.location }}
                      template(#cell(physical_location)="data")
                        div(v-if="physical_location_in_daily_dialogue") {{ data.item.physical_location ? data.item.physical_location.name : '-' }}
                        div(v-else)
                      template(#cell(feedback)="data")
                        div(style="font-weight: 700" :class="`text-${data.item.textColor}`")
                          | {{ $t(`label.${data.item.feedback}`) }}
                      template(#cell(detail)="data")
                        div(v-if="opinionId === data.item._id" v-html="data.item.detail")
                        div(v-else v-html="data.item.croppedDetail ? data.item.croppedDetail : data.item.detail")
                      template(#cell(actions)="data")
                        div.flex.flex-column
                          template(v-if="data.item.croppedDetail")
                            ViewButton(v-if="opinionId !== data.item._id" variant="flat-primary" @clicked="handleView(data.item._id)")
                            XButton(v-else @clicked="handleView(data.item._id)")
                          b-modal(
                            :id="`modal ${data.item._id}`"
                            centered
                            no-close-on-backdrop
                            modal-class="modal-danger"
                            ok-variant="danger"
                            cancel-variant="outline-secondary"
                            :title="$t('message.confirm_action')"
                            :ok-title="$t('message.delete')"
                            :cancel-title="$t('message.cancel')"
                            @ok="deleteCustomerOpinion(data.item._id)"
                          ) {{ $t('message.confirm_delete_customerOpinion') }}
                  // Pagination
                  b-col(v-if="isOnline && customersOpinions.length > 0" cols="12" class="d-flex justify-content-between flex-wrap")
                    .mb-1
                      b-form-group.mb-0
                        label.d-inline-block.text-sm-left.mr-50 {{ $t('message.per_page') }}
                        b-form-select(
                          id="perPageSelect"
                          v-model="perPage"
                          size="sm"
                          :options="[5,10,15,20,25,30,40,50,100]"
                          class="w-50"
                        )
                    .mb-1
                      span.text-muted {{ showingMessage }}
                    b-pagination(
                      v-model="currentPage"
                      :total-rows="totalOpinions"
                      :per-page="perPage"
                      first-number=""
                      last-number=""
                      prev-class="prev-item"
                      next-class="next-item"
                    )
                // No data message
                b-col(v-else cols="12" class="mt-3 p-0")
                  h6.no-data-message
                    | {{ $t('message.no_records') }}

        // Welcome
        tab-content(:title="$t('message.welcome')", :before-change="() => validateTab(welcomeTab)")
          validation-observer(ref="welcomeTab", tag="form") 
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | {{ $t('message.welcome_to_daily_dialogue') }}
                small.text-muted
                  | {{ $t('message.fill_to_start_meeting') }}
              b-col(v-if="information_module || showOnlyCustomersOpinions" md="12" class="mb-1 d-flex flex-column")
                label      
                  | {{ $t('label.Location') }}:
                h5
                  |  {{ filteredLocation }}
              b-col(md="6")
                b-form-group(
                  :label="$t('message.tableHeader.date')",
                  label-for="v-date"
                )
                  b-form-datepicker#v-date(v-model="meeting.date", :max="actualDate", :disabled="daily_dialogue_date_disabled")
              b-col.mb-1.mb-md-0(md="3")
                label
                  | {{ $t('label.start') }}
                validation-provider(:name="$t('label.start')", rules="required", v-slot="{ errors }")
                  b-input-group
                    b-form-input(
                      v-model="meetingStart",
                      type="time",
                    )
                  small(class="text-danger") {{ errors[0] }}

              b-col(v-if="!information_module && !showOnlyCustomersOpinions && physical_location_in_daily_dialogue" md="6")
                b-form-group(
                  :label="$t('label.Physical Location')",
                  label-for="v-location",
                  :description="$t('message.where_meeting_held')"
                )
                  validation-provider(:name="$t('label.Physical Location')", rules="required", v-slot="{ errors }")
                    v-select#v-location(
                      v-model="meeting.physical_location",
                      :options="filteredPhysicalLocations",
                      :selectable="(option) => !option.value.includes('select_value')",
                      label="title"
                    )
                    small(class="text-danger") {{ errors[0] }}

              b-col(v-if="!information_module && !showOnlyCustomersOpinions" md="6")
                b-form-group(
                  :label="$t('label.Location')",
                  label-for="v-location",
                  :description="$t('message.where_meeting_held')"
                )
                  validation-provider(:name="$t('label.Location')", rules="required", v-slot="{ errors }")
                    v-select#v-location(
                      v-model="meeting.location",
                      :options="filteredLocations",
                      :selectable="(option) => !option.value.includes('select_value')",
                      label="title"
                    )
                    small(class="text-danger") {{ errors[0] }}

        // Behaviour Suggestion
        tab-content(v-if="behaviorFunctionalityDD" :title="$t('message.behaviour_suggestion')")
          b-row
            b-col.mb-2(cols="12" class="d-flex justify-content-between align-items-center")
              h5.mb-0 {{ $t('message.behaviour_suggestion') }}
              b-button(variant="flat-primary" size="sm" @click="fetchSuggestedBehaviour(true)" :disabled="!meeting.location")
                feather-icon(icon="RefreshCwIcon" size="18")
            b-col(v-if="behaviourLoading" cols="12" class="text-center py-3")
              b-spinner(small)
            b-col(v-else-if="!suggestedBehaviour" cols="12" class="text-center py-3")
              h6.no-data-message {{ $t('message.no_behaviours_found') }}
            b-col(v-else cols="12")
              h6.text-primary.font-weight-bold.mb-1 {{ suggestedBehaviour.name }}
              span.d-block.text-warning.mb-1(v-if="suggestedBehaviour.value") {{ suggestedBehaviour.value.name }}
              p(v-if="suggestedBehaviour.description") {{ suggestedBehaviour.description }}
              div.mt-2(v-if="suggestedBehaviour.imageKey")
                b-spinner(v-if="behaviourImgLoading" small)
                div(v-else-if="behaviourImgSrc" @click="openImage(suggestedBehaviour.imageKey)" class="image-container" style="display:inline-block; cursor:pointer;")
                  img(:src="behaviourImgSrc" style="max-height: 300px; border-radius: 4px; margin-bottom: 1rem")
                  span.hover-text {{ $t('message.tableHeader.fullSize') }}

        // Happiness
        tab-content(:title="$t('Mood')", :before-change="() => validateTab(happinessTab, false, isManualMoodRegistration, true)")
          validation-observer(ref="happinessTab", tag="form") 
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | {{ $t('message.how_team_feeling') }}
                small.text-muted
                  | {{ $t('message.count_amount_happiness') }}
              b-col(md="4", class="d-flex flex-column")
                img(v-if="useBatteryIcons", :src="batteryIcons.happy", width="100", height="100", class="align-self-center", alt="Battery 1")
                feather-icon.text-success.stroke-current(v-else, icon="SmileIcon", size="100", class="align-self-center")
                b-form-group(:label="useBatteryIcons ? $t('label.high') : $t('label.happy')", label-for="v-happy")
                  validation-provider(:name="$t('label.happy')", rules="required|integer|min_value:0|max_value:100", v-slot="{ errors }")
                    b-input-group
                      b-input-group-prepend(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('happy','remove')")
                          feather-icon(icon="MinusIcon")
                      b-form-input(type="number", v-model="meeting.happy", style="text-align:center", :disabled="mood_only_by_survey")
                      b-input-group-append(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('happy','add')")
                          feather-icon(icon="PlusIcon")
                    small(class="text-danger") {{ errors[0] }}
                div(class="align-self-center")
                  | {{ happyPercentage }}%
              b-col(md="4", class="d-flex flex-column my-1 my-md-0")
                img(v-if="useBatteryIcons", :src="batteryIcons.neutral", width="100", height="100", class="align-self-center", alt="Battery 2")
                feather-icon.text-warning.stroke-current(v-else, icon="MehIcon", size="100", class="align-self-center")
                b-form-group(:label="useBatteryIcons ? $t('label.medium') : $t('label.neutral')", label-for="v-neutral")
                  validation-provider(:name="$t('label.neutral')", rules="required|integer|min_value:0|max_value:100", v-slot="{ errors }")
                    b-input-group
                      b-input-group-prepend(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('neutral','remove')")
                          feather-icon(icon="MinusIcon")
                      b-form-input(type="number", v-model="meeting.neutral", style="text-align:center", :disabled="mood_only_by_survey")
                      b-input-group-append(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('neutral','add')")
                          feather-icon(icon="PlusIcon")
                    small(class="text-danger") {{ errors[0] }}
                div(class="align-self-center")
                  | {{ neutralPercentage }}%
              b-col(md="4", class="d-flex flex-column")
                img(v-if="useBatteryIcons", :src="batteryIcons.sad", width="100", height="100", class="align-self-center", alt="Battery 3")
                feather-icon.text-danger.stroke-current(v-else, icon="FrownIcon", size="100", class="align-self-center")
                b-form-group(:label="useBatteryIcons ? $t('label.low') : $t('label.Sad_Angry')", label-for="v-sad-angry")
                  validation-provider(:name="$t('label.Sad_Angry')", rules="required|integer|min_value:0|max_value:100", v-slot="{ errors }")
                    b-input-group
                      b-input-group-prepend(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('sad','remove')")
                          feather-icon(icon="MinusIcon")
                      b-form-input(type="number", v-model="meeting.sad", style="text-align:center", :disabled="mood_only_by_survey")
                      b-input-group-append(v-if="!mood_only_by_survey")
                        b-button(variant="outline-primary", @click="updateHappiness('sad','add')")
                          feather-icon(icon="PlusIcon")
                    small(class="text-danger") {{ errors[0] }}
                div(class="align-self-center")
                  | {{ sadPercentage }}%
            b-row.mt-3
              b-button(v-if="comments.length" class="ml-1 mb-2" variant="outline-primary" size="sm" @click="() => showComments = !showComments")
                | {{ showComments ? $t('message.hideComments') : $t('message.showComments') }}
              b-col.mb-1(v-if="showComments && comments.length", cols="12")
                b-table-simple(hover, small, caption-top, responsive)
                  b-thead
                      b-tr
                        th {{ $t('message.tableHeader.state') }}
                        th {{ $t('message.tableHeader.comments') }}
                      b-tr(v-for="(comment, index) in comments", :key="index")
                        b-td(v-if="comment.comment" :class="stateVariants[comment.answer]") {{ $t(`happiness.${comment.answer}`) }}
                        b-td(v-if="comment.comment" :class="stateVariants[comment.answer]") {{ comment.comment }}
            b-row.mb-1
              b-col.my-1(v-if="isManualMoodRegistration", md="3")
                b-button(variant="warning", @click="openIndividualResponseModal")
                  | {{ $t('message.individualResponse') }}
                small.mt-1.d-block(v-if="offlineResponsesCount > 0")
                  | {{ $t('message.loadedResponses') }}: {{ offlineResponsesCount }}
              b-col.my-1(md="9")
                b-button(variant="primary", :disabled="!meeting.location || (physical_location_in_daily_dialogue && !meeting.physical_location) || isFetchingSurveyResults", @click="updateHappinessFromSurvey")
                  | {{ $t('message.get_survey_results') }}
                span.ml-1(v-show="isFetchingSurveyResults")
                  | {{ $t('message.fetching_survey_results') }}
            b-row.mt-1(v-if="!happinessReady")
              b-col(cols="12" class="d-flex justify-content-end")
                span.text-danger(style="font-weight: bold; font-size: 1rem;") {{ $t('message.get_survey_results_to_advance') }}

          b-modal(v-model="showIndividualModal", hide-footer, centered, size="lg")
            div.text-center(v-if="!responseSent")
              h4.mb-2 {{ $t('how_are_you_feeling_today') }}

              //- Mood Selection
              b-row
                b-col(sm="4")
                  b-button(class="mx-2 my-1", variant="outline-success", :pressed="selectedMood === 'happy'", @click="selectedMood = 'happy'")
                    feather-icon(icon="SmileIcon", size="80", class="text-success")

                b-col(sm="4")
                  b-button(class="mx-2 my-sm-1", variant="outline-warning", :pressed="selectedMood === 'neutral'", @click="selectedMood = 'neutral'")
                    feather-icon(icon="MehIcon", size="80", class="text-warning")

                b-col(sm="4")
                  b-button(class="mx-2 my-1", variant="outline-danger", :pressed="selectedMood === 'sad'", @click="selectedMood = 'sad'")
                    feather-icon(icon="FrownIcon", size="80", class="text-danger")

              //- Comment
              b-row(class="mt-2")
                b-col(cols="12")
                  b-form-group(:label="$t('message.feel_free_to_share_comment')")
                    b-form-textarea(v-model="singleAnswerComment", rows="3", maxlength="254")
                  small(class="text-danger d-block text-right mt-1")
                    | {{ 254 - singleAnswerComment.length }} characters

              b-button.mt-2(variant="primary", :disabled="!selectedMood", @click="submitIndividualResponse")
                | {{ $t('message.submit') }}

            div.text-center(v-else)
              h4.mb-3
                | {{ $t('thank_you_submitting_response') }}

              b-button(variant="secondary", @click="showIndividualModal = false")
                | {{ $t('Close') }}

        // attendees
          tab-content(title="Attendees")
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | Attendees
                small.text-muted Enter the correspoding user(s) for each level of responsability.

              add-attendee(@update-attendees="updateAttendees")

        // Recognitions
        tab-content(:title="$t('label.recognitions')", :before-change="() => validateTab(recognitionsTab)")
          validation-observer(ref="recognitionsTab", tag="form")  
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | {{ $t('message.team_done_well') }}
                small.text-muted
                  | {{ $t('message.recognition_for_efforts') }}

              add-recognition(
                :workers="workersTotalNotMapped",
                :motives="motives",
                @update-recognitions="updateRecognitions",
              )

        // Improvements
        tab-content(:title="$t('label.improvements')", :before-change="() => validateTab(improvementsTab)")
          validation-observer(ref="improvementsTab", tag="form")   
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | {{ $t('message.what_improved') }}
                small.text-muted
                  | {{ $t('message.get_feedback') }}

              add-improvement(
                :domains="domains",
                :workers="workersTotalNotMapped",
                :metadata="metadataNotMapped"
                @update-improvements="updateImprovements",
              )

        // Finish
        tab-content(:title="$t('message.finish')", :before-change="() => validateTab(finishTab, true)", :id="'finishTab'", :tab-id="'finishTab'" class="mb-1")
          validation-observer(ref="finishTab", tag="form") 
            b-row
              b-col.mb-2(cols="12")
                h5.mb-0
                  | {{ $t('message.daily_dialogue_end') }}
                small.text-muted
                  | {{ $t('message.complete_end_time') }}
              b-col(md="6")
                b-form-group(
                  :label="$t('message.tableHeader.date')",
                  label-for="v-date"
                )
                  b-form-datepicker#v-date(v-model="meeting.date", :disabled="true")

              b-col(md="6")
                b-form-group(
                  :label="$t('Image')",
                  label-for="v-image",
                )
                  b-button.mr-1(
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                    type="button",
                    variant="info",
                    @click="uploadImage()"
                  )
                    | {{ $t('message.upload') }}
                  image-compressor(
                    style="display: none",
                    :done="getImgCompressed",
                    ref="compressor"
                  )
                  small(v-if="imgData.fileInfo")
                    | {{imgData.fileInfo.name}}
                  small(v-else-if="daily_dialogue_image_required", class="text-danger")
                    | {{ $t('message.upload_image_required') }}
                  
              b-col.mb-1.mb-md-0(md="3")
                label
                  | {{ $t('label.start') }}
                validation-provider(:name="$t('label.start')", rules="required", v-slot="{ errors }")
                  b-input-group
                    b-form-input(
                      v-model="meetingStart",
                      type="time",
                      :disabled="true"
                    )
                  small(class="text-danger") {{ errors[0] }}
              b-col.mb-1.mb-md-0(md="3")
                label
                  | {{ $t('label.end') }}
                validation-provider(:name="$t('label.end')", rules="required", v-slot="{ errors }")
                  b-input-group
                    b-form-input(
                      v-model="meetingEnd",
                      type="time",
                    )
                  small(class="text-danger") {{ errors[0] }}
  b-col(v-else cols="12")
    b-card(
      class="text-primary d-flex flex-column text-center mb-0"
      style="height: 70vh !important; padding-top: 10rem"
    )
      feather-icon(
        icon="CheckCircleIcon"
        size="30"
        class="text-success"
      )
      h4(class="text-primary mt-2") {{ $t('action_completed') }}
      h5(class="text-secondary mt-2") {{ $t(`${confirmationPage.msg}`) }}
      b-button(
        @click="$router.push(confirmationPage.route)"
        variant="primary"
        class="mt-2"
      ) Ok


</template>

<script>
import vSelect from "vue-select"
import "vue-form-wizard/dist/vue-form-wizard.min.css"
import { FormWizard, TabContent } from "vue-form-wizard"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import { BCardText, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BButton, BFormDatepicker, BFormTimepicker, BFormSpinbutton, BInputGroup, BInputGroupPrepend, BInputGroupAppend, BCardBody, BTable, BPagination, BTableSimple, BThead, BTr, BTd, BSpinner } from "bootstrap-vue"
import AddAttendee from "./AddAttendee.vue"
import AddRecognition from "./AddRecognition.vue"
import AddImprovement from "./AddImprovement.vue"
import i18n from "@/libs/i18n"
import { ref, onMounted, watch, computed } from "@vue/composition-api"
import useCommon from '@/views/organization/useCommon'
import store from "@/store"
import { useRouter } from '@core/utils/utils'
import useNotifications from '@/composables/useNotifications'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, integer, min_value, max_value } from "@validations"
import useCommonDashboards from '@/views/habit/useCommonDashboards'
import Ripple from 'vue-ripple-directive'
import ImageCompressor from '@/views/habit/ImageCompressor.vue'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'
import useCommunications from '.././communications/useCommunications'
import useCustomersOpinions from '@/views/habit/customersOpinions/useCustomersOpinions'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ViewButton from '@/views/components/Shared/Buttons/ViewButton.vue'
import XButton from '@/views/components/Shared/Buttons/XButton.vue'
import { colors } from '@/constants'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import { getDeviceId } from '@/helpers/deviceHelpers'
import Battery1 from '@/assets/images/svg/Battery1.svg'
import Battery2 from '@/assets/images/svg/Battery2.svg'
import Battery3 from '@/assets/images/svg/Battery3.svg'
import endpoints from '@/libs/endpoints'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BFormDatepicker,
    BFormTimepicker,
    BFormSpinbutton,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BCardBody,
    BTable,
    BPagination,
    BTableSimple,
    BThead,
    BTr,
    BTd,
    vSelect,
    ToastificationContent,
    AddAttendee,
    AddRecognition,
    AddImprovement,
    ValidationObserver,
    ValidationProvider,
    ImageCompressor,
    Loading,
    ViewButton,
    XButton,
    BCardText,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { router } = useRouter()
    const { showSuccessMessage, showErrorMessage } = useNotifications()
        const { getWorkersTotalForDropDown, workersTotalNotMapped, getLocationsForDropDown, locations, getPhysicalLocationsForDropDown, physical_locations, getMotivesForDropDown, motives, getMetadataForDropDown, metadataNotMapped, getSupervisorsForDropDown, supervisorsOnlyNames, handleError, storeDataToUpload, formatDatePicker, openImage } = useCommon()
    const { getEmailImprovementTemplate, formatEmailDate, uploadFileToS3 } = useCommonTodo()
    const { getDomains, updateDailyDialogueWithKey } = useCommonDashboards()
    const { listCommunications, communications, isLoading } = useCommunications()
    const { listCustomersOpinions, customersOpinions, currentPage, perPage, tableColumns, sortBy, isSortDirDesc, opinionId, handleView, showingMessage, totalOpinions } = useCustomersOpinions()
    const { createItem, createItems, getItem, getItems, updateItems, updateItem, sendEmail, getItemsAggregate, getPresignedDownloadUrl } = useLambda()
    const userData = store.state?.userStore?.userData;
    const userId = userData.worker_id != null ? userData.worker_id.$oid : null
    const worker_id = userData.role !== "admin" ? userData.worker_id.$oid : null;
    const client_id = userData.role !== "admin" ? userData.client.$oid : null;
    const userLocation = (userData.role !== "admin" && userData.locations?.length) ? userData.locations[0] : null;
    const userPhysicalLocation = (userData.role !== "admin" && userData.physical_locations?.length) ? userData.physical_locations[0] : null;
    // Ids inside userData may come as extended JSON ({ $oid }) instead of plain strings
    const getIdString = (id) => (id?.$oid || id)?.toString() || null
    // Only the locations and physical locations assigned to the logged-in user (found in
    // userData) may be selected. Consultants are not restricted and see every option.
    const userLocationIds = (userData.role !== "consultant" && userData.locations?.length)
      ? userData.locations.map(l => getIdString(l.value)).filter(Boolean)
      : null
    const userPhysicalLocationIds = (userData.role !== "consultant" && userData.physical_locations?.length)
      ? userData.physical_locations.map(p => getIdString(p.value)).filter(Boolean)
      : null
    const showOnlyCustomersOpinions = userData.customerOpinionView
    const { daily_dialogue_image_required, daily_dialogue_date_disabled, mood_only_by_survey, behavior_functionality_daily_dialogue: behaviorFunctionalityDD } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const isSubmitting = ref(false)
    const surveyResultsFetched = ref(false)
    const manualHappinessChanged = ref(false)
    const welcomeTab = ref(null)
    const happinessTab = ref(null)
    const recognitionsTab = ref(null)
    const improvementsTab = ref(null)
    const finishTab = ref(null)
    const { default_language, information_module, physical_location_in_daily_dialogue } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const actualDate = new Date()
    const actualDateToShow = actualDate.toLocaleDateString(`${default_language || 'en'}-US`)
    const sevenDaysBefore = new Date(actualDate)
    sevenDaysBefore.setDate(actualDate.getDate() - 7)
    const sevenDaysBeforeToShow = sevenDaysBefore.toLocaleDateString(`${default_language || 'en'}-US`)
    const actualDatePlus15Min = ref(new Date())
    // actualDatePlus15Min.value.setMinutes(actualDate.getMinutes() + 15 );
    const isOnline = computed(() => store.state.app.isOnline)
    const compressor = ref(null)
    const imgData = ref({})
    const isFetchingSurveyResults = ref(false)
    const showComments = ref(false)
    const confirmationPage = ref({ route: '', msg: ''})
    const domains = computed(() => getDomains(client_id))
    const filteredLocation = ref('')
    const comments = ref([])
    const stateVariants = { happy: 'text-success', neutral: 'text-warning', sad: 'text-danger' }
    const selectedLocation = ref(userLocation)
    const useBatteryIcons = ref(false)
    const batteryIcons = { happy: Battery1, neutral: Battery2, sad: Battery3 }
    const dailyDialogue = ref(null)
    const suggestedBehaviour = ref(null)
    const behaviourImgSrc = ref(null)
    const behaviourImgLoading = ref(false)
    const behaviourLoading = ref(false)

    const fetchSuggestedBehaviour = async (updatePartialSave = false) => {
      if (!behaviorFunctionalityDD || !client_id) return
      const locationId = meeting.value.location?.value
      if (!locationId) return

      const currentBehaviourId = suggestedBehaviour.value?._id
      suggestedBehaviour.value = null
      behaviourImgSrc.value = null
      behaviourLoading.value = true

      try {
        // Fetch all behaviours for this client with their associated value name
        const behaviourPipeline = [
          { $match: { client_id: oid(client_id), deleted: { $ne: true } } },
          { $lookup: { from: 'value', localField: 'value_id', foreignField: '_id', as: 'value',
            pipeline: [{ $project: { name: 1 } }, { $addFields: { _id: { $toString: '$_id' } } }] } },
          { $addFields: { _id: { $toString: '$_id' }, value: { $arrayElemAt: ['$value', 0] } } },
        ]
        const behaviours = await getItemsAggregate({ collection: 'behaviour', pipeline: behaviourPipeline })
        if (!behaviours?.length) return

        // Count how many times each behaviour has been suggested for this location
        const meetingMatchQuery = {
          client_id: oid(client_id),
          location: oid(locationId),
          suggested_behaviour_id: { $exists: true },
        }
        if (physical_location_in_daily_dialogue && meeting.value.physical_location?.value) {
          meetingMatchQuery.physical_location = oid(meeting.value.physical_location.value)
        }
        const usagePipeline = [
          { $match: meetingMatchQuery },
          { $group: { _id: { $toString: '$suggested_behaviour_id' }, count: { $sum: 1 } } },
        ]
        let usageCounts = []
        try {
          usageCounts = await getItemsAggregate({ collection: 'meeting', pipeline: usagePipeline }) || []
        } catch (err) {
          console.log(err)
        }

        // Build usage map and assign count to each behaviour
        const usageMap = {}
        usageCounts.forEach(u => { usageMap[u._id] = u.count })
        behaviours.forEach(b => { b._usageCount = usageMap[b._id] || 0 })

        // Pick randomly among the least-used behaviours, excluding the current one
        const minCount = Math.min(...behaviours.map(b => b._usageCount))
        let leastUsed = behaviours.filter(b => b._usageCount === minCount)
        if (currentBehaviourId) {
          const withoutCurrent = leastUsed.filter(b => b._id !== currentBehaviourId)
          if (withoutCurrent.length) leastUsed = withoutCurrent
          else leastUsed = behaviours.filter(b => b._id !== currentBehaviourId)
        }
        const selected = leastUsed[Math.floor(Math.random() * leastUsed.length)]
        suggestedBehaviour.value = selected

        // If a partial daily dialogue already exists (e.g. after refresh), update it in DB
        if (updatePartialSave && dailyDialogue.value?._id && selected?._id) {
          try {
            await updateItem({
              collection: 'meeting',
              query: { _id: oid(dailyDialogue.value._id) },
              action: { $set: { suggested_behaviour_id: oid(selected._id) } },
            })
          } catch (err) {
            console.log(err)
          }
        }

        // Load image thumbnail
        if (selected?.imageKey) {
          behaviourImgLoading.value = true
          try {
            const { url } = await getPresignedDownloadUrl({ key: selected.imageKey })
            const response = await fetch(url)
            if (response.ok) behaviourImgSrc.value = await response.text()
          } catch (err) {
            console.log(err)
          } finally {
            behaviourImgLoading.value = false
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        behaviourLoading.value = false
      }
    }

    const meeting = ref({
      date: actualDate,
      happy: 0,
      neutral: 0,
      sad: 0,
      recognitions: [],
      improvements: [],
      // The location is resolved in onMounted against the loaded options, so it always
      // carries the physical_location field needed to filter by physical location
      location: null,
      physical_location: null,
    })

    // These variables are defined separately in order to be watched
    const meetingStart = ref(
      actualDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    )

    const meetingEnd = ref(
      actualDatePlus15Min.value.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }))
    
    const totalHappiness = computed(() => parseInt(meeting.value.happy) + parseInt(meeting.value.neutral) + parseInt(meeting.value.sad))
    const happyPercentage = computed(() => totalHappiness.value ? Math.round(meeting.value.happy / totalHappiness.value * 100) : 0)
    const neutralPercentage = computed(() => totalHappiness.value ? Math.round(meeting.value.neutral / totalHappiness.value * 100) : 0)
    const sadPercentage = computed(() => totalHappiness.value ? Math.round(meeting.value.sad / totalHappiness.value * 100) : 0)

    const happinessReady = ref(true)
    // const happinessReady = computed(() => {
    //   if (mood_only_by_survey) return surveyResultsFetched.value
    //   return surveyResultsFetched.value || manualHappinessChanged.value
    // })

    const activeTabIndex = ref(0)
    const happinessTabIndex = computed(() => ((information_module || showOnlyCustomersOpinions) ? 2 : 1) + (behaviorFunctionalityDD ? 1 : 0))
    const isHappinessTabActive = computed(() => activeTabIndex.value === happinessTabIndex.value)

    // For client Explora, the department HH and physical location Rapa Nui register the mood manually due to low internet signal
    // TODO: Change this hardcoded client ID logic to a more generic one
    const isManualMoodRegistration = computed(() => {
      return meeting.value.location?.value === '688bd33dc09d7b68855390a5' && meeting.value.physical_location?.value === '692ee55153772ee4e6d89aa6'
  })

    // This function needs to be defined with "function handle..." instead of "const handle..." in order to use "this.$refs"
    function handleTabChange(oldTab, newTab) {
      activeTabIndex.value = newTab
      const tabs = this.$refs.myForm.tabs;
      const lastIndex = tabs.length - 1;
      if (lastIndex === newTab) {
        actualDatePlus15Min.value = new Date();
        meetingEnd.value = actualDatePlus15Min.value.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      }
      if (behaviorFunctionalityDD && !suggestedBehaviour.value) {
        const behaviourTabIdx = (information_module || showOnlyCustomersOpinions) ? 2 : 1
        if (newTab === behaviourTabIdx) fetchSuggestedBehaviour()
      }
    }

    // Physical location options are restricted to the ones assigned to the logged-in user
    const filteredPhysicalLocations = computed(() => {
      if (!userPhysicalLocationIds) return physical_locations.value
      return physical_locations.value.filter(pl => userPhysicalLocationIds.includes(pl.value))
    })

    const filteredLocations = computed(() => {
      // Location options are restricted to the ones assigned to the logged-in user
      let opts = userLocationIds
        ? locations.value.filter(loc => userLocationIds.includes(loc.value))
        : locations.value
      if (physical_location_in_daily_dialogue && meeting.value.physical_location?.value) {
        opts = opts.filter(loc => loc.physical_location === meeting.value.physical_location.value)
      }
      return opts
    })

    // Single source of truth for the location selection: whenever the valid options change
    // (locations loaded/reloaded or physical location changed), keep the current selection
    // only if it is still a valid option; otherwise never leave a location from another
    // physical location selected
    watch(filteredLocations, (opts) => {
      const current = meeting.value.location
      if (current && opts.some(o => o.value === current.value)) return
      meeting.value.location = opts.length === 1 ? opts[0] : null
    })

    watch([meeting, locations], async () => {
      if (meeting.value.location?.value !== selectedLocation.value?.value) {
        getHappinessIcons(meeting.value.location?.value)
        selectedLocation.value = meeting.value.location
      }
      listCustomersOpinions('new', actualDate, meeting.value.location?.value)
      listCommunications(actualDate, meeting.value.location)
      filteredLocation.value = meeting.value.location?.title
      await getExistingDialogue()
    },{ deep: true })
    
    watch(meetingStart, () => {
        // Update meeting end time
        const [hoursString, minutesString] = meetingStart.value.split(":")
        const hours = parseInt(hoursString)
        const minutes = parseInt(minutesString)
        let endHours = minutes < 45 ? hours : hours + 1
        let endMinutes = minutes < 45 ? minutes + 15 : minutes - 45
        if (endHours === 24) endHours = 0
        if (endHours < 10) endHours = `0${endHours}`
        if (endMinutes < 10) endMinutes = `0${endMinutes}`
        const endTime = `${endHours}:${endMinutes}`
        meetingEnd.value = endTime
    })
  
    watch(metadataNotMapped, val => {
      if (val && val.length) {
        val.forEach(e => {
          // Set default creation date and column width for UI purposes
          if (e.name === "creation_date") {
            e.answer = `${actualDate.getFullYear()}-${actualDate.getMonth() < 9 ? "0" + (actualDate.getMonth() + 1) : actualDate.getMonth() + 1}-${actualDate.getDate() < 10 ? "0" + actualDate.getDate() : actualDate.getDate()}`
            e.columnWidth = 2
          }
          // Set default instance leader and update instance leader options with supervisors
          if (e.name === "instance_leader") {
            e.answer = userData.username
            e.options = supervisorsOnlyNames.value
          }
        })
      }
    })

    watch(supervisorsOnlyNames, val => {
      if (metadataNotMapped.value && metadataNotMapped.value.length) {
        metadataNotMapped.value.forEach(e => {
          // Update instance leader options with supervisors
          if (e.name === "instance_leader") {
            e.options = val
          }
        })
      }
    })

    // When the happiness tab is activated, automatically fetch the survey results to update the mood values
    watch(isHappinessTabActive, val => {
      if (val) {
        updateHappinessFromSurvey()
      }
    })

    const updateRecognitions = (recognitions) => {
      meeting.value.recognitions = recognitions;
    }

    const updateImprovements = (improvements) => {
      meeting.value.improvements = improvements;
    }

    const updateHappiness = (state, change) => {
      if (change === "add" && meeting.value[state] < 100) {
        meeting.value[state]++
        manualHappinessChanged.value = true
      } else if (change === "remove" && meeting.value[state] > 0) {
        meeting.value[state]--
        manualHappinessChanged.value = true
      }
    }

    const formSubmitted = async () => {
      if (isSubmitting.value) return
      isSubmitting.value = true

      const dateTime = formatDatePicker(meeting.value.date)

      const payload = {
        client_id: client_id,
        created_by: userId,
        date: date(dateTime),
        start: meetingStart.value.length === 4 ? `0${meetingStart.value}` : meetingStart.value,
        end: meetingEnd.value.length === 4 ? `0${meetingEnd.value}` : meetingEnd.value,
        happy: parseInt(meeting.value.happy),
        neutral: parseInt(meeting.value.neutral),
        sad: parseInt(meeting.value.sad),
        location: meeting.value.location.value,
        partial: false,
        improvements: meeting.value.improvements?.map((i) => {
          const improvement = {
            client_id: client_id,
            note: i.note,
            domain: i.domain,
            assignee: i.assignee?._id || null,
            description: '',
            tags: [i.domain],
            completed: false,
            deleted: false,
            important: false,
            metadata: i.metadata?.map(metadata => ({
              name: metadata.name,
              type: metadata.type,
              answer: metadata.answer,
            })) || [],
            origin: 'daily_dialogue',
            created_by: oid(userId),
            creation_date: date(new Date())
          }

          if (i.dueDate) improvement.dueDate = date(new Date(`${i.dueDate.slice(0, 10)} 12:00:00`))

          return improvement
        }) || [],
        recognitions: meeting.value.recognitions?.map((i) => ({
          client_id: client_id,
          note: i.note,
          worker: i.worker?._id,
          motive: i.motive,
          created_by: worker_id,
          date: date(dateTime)
        })) || [],
      };

      if (physical_location_in_daily_dialogue) {
        payload.physical_location = meeting.value.physical_location.value
      }

      if (behaviorFunctionalityDD && suggestedBehaviour.value?._id) {
        payload.suggested_behaviour_id = suggestedBehaviour.value._id
      }

      try {
        if (isManualMoodRegistration.value) {
          if (comments.value?.length) {
            const surveysToCreate = comments.value.map(e => ({
              ...e,
              location: oid(payload.location),
              physical_location: payload.physical_location ? oid(payload.physical_location) : null,
              createdAt: date(new Date(e.createdAt)),
              read: true,
            }))
  
            const { insertedIds: newSurveyIds } = await createItems({ collection: 'employee_survey', payload: surveysToCreate })
            if (newSurveyIds?.length) {
              payload.employeeSurveys = Object.values(newSurveyIds).map(e => e.toString())
            }
          }
        } else {
          const surveyData = await getSurveyResults()
          if (surveyData?.length) {
            payload.employeeSurveys = surveyData.map(e => e._id)
            if (mood_only_by_survey) {
              const categories = { happy: 0, neutral: 0, sad: 0 }
              surveyData.forEach(e => {
                categories[e.answer]++
              })
              payload.happy = categories.happy
              payload.neutral = categories.neutral
              payload.sad = categories.sad
            }
          }
        }
      } catch (error) {
        console.log(error)
      }

      if (isOnline.value) {
        postDailyDialogue(payload)  
      }
      else {
        payload.imgData = imgData.value
        payload.improvementsNotMapped = meeting.value.improvements
        payload.employeeSurveysToUpload = comments.value

        // The data stored in IndexedDB can't have ObjectIds, they must be all in string format
        storeDataToUpload('dialoguesToUpload', payload)

        // showSuccessMessage(i18n.t('message.form_stored'))
        // router.push({ name: 'apps-calendar' })
        showConfirmationPage({ name: 'apps-calendar' }, 'message.form_stored')
      }
    }

    const postDailyDialogue = async (payload) => {
      try {
        payload.client_id = oid(payload.client_id)
        payload.created_by = oid(payload.created_by)
        payload.location = oid(payload.location)
        if (payload.physical_location) payload.physical_location = oid(payload.physical_location)
        if (payload.employeeSurveys) payload.employeeSurveys = payload.employeeSurveys.map(e => oid(e))
        if (payload.suggested_behaviour_id) payload.suggested_behaviour_id = oid(payload.suggested_behaviour_id)

        // Create recognitions
        if (payload.recognitions?.length) {
          const recognitionsToCreate = payload.recognitions.map(e => ({
            ...e,
            client_id: oid(e.client_id),
            worker: oid(e.worker),
            motive: oid(e.motive),
            created_by: oid(e.created_by),
          }))

          const { insertedIds: newRecognitionIds } = await createItems({ collection: 'recognition', payload: recognitionsToCreate })
          payload.recognitions = Object.values(newRecognitionIds).map(id => oid(id))
        }

        // Create improvements
        if (payload.improvements?.length) {
          const improvementsToCreate = payload.improvements.map(e => ({
            ...e,
            client_id: oid(e.client_id),
            assignee: oid(e.assignee),
          }))

          const { insertedIds: newImprovementIds } = await createItems({ collection: 'improvement', payload: improvementsToCreate })
          payload.improvements = Object.values(newImprovementIds).map(id => oid(id))
        }

        let dailyDialogueId = dailyDialogue.value?.partial ? dailyDialogue.value._id?.toString() : ''

        if (!dailyDialogue.value || !dailyDialogue.value.partial) {
          const { insertedId } = await createItem({ collection: 'meeting', payload })
          dailyDialogueId = insertedId
          if (!insertedId) throw new Error('Item not created')
        } else {
          await updateItem({ collection: 'meeting', query: { _id: oid(dailyDialogue.value._id) }, action: { $set: payload }})
        }

        // Mark location's employee survey results as read
        const meetingDateZeroHours = formatDatePicker(meeting.value.date)
        meetingDateZeroHours.setHours(0, 0, 0, 0)
        const meetingDateNextDay = new Date(meetingDateZeroHours)
        meetingDateNextDay.setDate(meetingDateNextDay.getDate() + 1)

        const query = {
          location: oid(meeting.value.location.value),
          createdAt: { $gte: date(meetingDateZeroHours), $lt: date(meetingDateNextDay) }
        }
        const action = { $set: { read: true } }

        try {
          await updateItems({ collection: 'employee_survey', query, action })
        } catch (error) {
          console.log(error)
        }
          
        // Upload image to AWS and then update the daily dialogue in MongoDB with the AWS image key
        const { fileInfo, destinationFolder } = imgData.value
        if (fileInfo) {
          uploadFileToS3(fileInfo, destinationFolder)
            .then((key) => updateDailyDialogueWithKey(dailyDialogueId, key))
            .catch((err) => console.log(err))
        }
        
        // Send email to assignees with the details of the improvements opportunity created
        meeting.value.improvements?.forEach(e => {
          if (e.assignee?.email) {
            const subject = i18n.t('message.improvement_opportunity_assigned')
            let bodyData = {
              title: e.note,
              name: e.assignee?.name,
              assignee: e.assignee?.name,
              tags: e.domain ? i18n.t(`domain.${e.domain}`) : '',
              creator: userData.fullName,
              dueDate: formatEmailDate(e.dueDate),
            }
            if (e.metadata?.length) {
              e.metadata.forEach(e => {
                if (e.name === "creation_date") e.answer = formatEmailDate(e.answer)
                Object.assign(bodyData, {[e.name]: e.answer})
              })
            }
            const body = getEmailImprovementTemplate(bodyData)
            
            sendEmail({ to: [e.assignee.email], subject, htmlBody: body })
              .then((response) => {
                if (response.MessageId) showSuccessMessage(i18n.t('message.email_send_improvement_success'))
              })
              .catch((err) => {
                console.log(err)
                showErrorMessage(i18n.t('message.email_send_improvement_error'))
              })
          }
        })
        
        // Redirect to happiness dashboard
        // router.push({ name: 'habit-happiness-dashboard' })
        showConfirmationPage({ name: 'habit-happiness-dashboard' }, 'message.daily_dialogue_created')
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.daily_dialogue_error'))
        isSubmitting.value = false
      }
    }

    const uploadImage = () => {
      compressor.value.$el.click()
    }

    const getImgCompressed = (obj) => {
      imgData.value = {
        fileInfo: obj.compressed,
        destinationFolder: `${userData.client.$oid}/daily-dialogues`
      }
    }

    const getSurveyResults = async () => {
      const meetingDateZeroHours = formatDatePicker(meeting.value.date)
      meetingDateZeroHours.setHours(0, 0, 0, 0)
      const meetingDateNextDay = new Date(meetingDateZeroHours)
      meetingDateNextDay.setDate(meetingDateNextDay.getDate() + 1)

      const query = {
        location: oid(meeting.value.location.value),
        createdAt: { $gte: date(meetingDateZeroHours), $lt: date(meetingDateNextDay) },
        read: false,
      }

      if (physical_location_in_daily_dialogue) {
        query.physical_location = oid(meeting.value.physical_location.value)
      }

      try {
        const items = await getItems({ collection: 'employee_survey', query, options: { projection : { answer: 1, comment: 1 } } })
        if (!items?.length) return []

        // Update the documents by adding readPartial: true
        await updateItems({
          collection: 'employee_survey',
          query: { _id: { $in: items.map(e => oid(e._id)) } },
          action: { $set: { readPartial: true } },
        })

        items?.forEach(e => e._id = e._id.toString())

        return items || []
      } catch (error) {
        console.log(error)
      }
    }

    const updateHappinessFromSurvey = async () => {
      if (isManualMoodRegistration.value || !isOnline.value) {
        getManualResponses()
        surveyResultsFetched.value = true
        return
      }

      isFetchingSurveyResults.value = true
      showComments.value = true
      const categories = { happy: 0, neutral: 0, sad: 0 }

      try {
        const surveyData = await getSurveyResults()
        surveyData.forEach(e => {
          categories[e.answer]++
        })
        comments.value = surveyData
        meeting.value.happy = categories.happy
        meeting.value.neutral = categories.neutral
        meeting.value.sad = categories.sad
        surveyResultsFetched.value = true
        showSuccessMessage(i18n.t('message.survey_results_fetch_successful'))

        const dateTime = formatDatePicker(meeting.value.date)

        // payload to create or update the daily dialogue in the DB
        const payload = {
          client_id: oid(client_id),
          created_by: oid(userId),
          location: oid(meeting.value.location.value),
          date: date(dateTime),
          employeeSurveys: surveyData.map(e => oid(e._id)),
          partialStart: meetingStart.value.length === 4 ? `0${meetingStart.value}` : meetingStart.value,
          partialEnd: meetingEnd.value.length === 4 ? `0${meetingEnd.value}` : meetingEnd.value,
          happy: parseInt(meeting.value.happy),
          neutral: parseInt(meeting.value.neutral),
          sad: parseInt(meeting.value.sad),
          partial: true, // Indicar que es un registro parcial
        }

        if(physical_location_in_daily_dialogue) {
          payload.physical_location = oid(meeting.value.physical_location.value)
        }

        if (behaviorFunctionalityDD && suggestedBehaviour.value?._id) {
          payload.suggested_behaviour_id = oid(suggestedBehaviour.value._id)
        }

        if (dailyDialogue.value?._id) {
          // If it already exists, update the daily dialog with the new answers
          const partialSetFields = { employeeSurveys: payload.employeeSurveys, happy: payload.happy, neutral: payload.neutral, sad: payload.sad, created_by: payload.created_by }
          if (payload.suggested_behaviour_id) partialSetFields.suggested_behaviour_id = payload.suggested_behaviour_id
          await updateItem({
            collection: 'meeting',
            query: { _id: oid(dailyDialogue.value._id) },
            action: { $set: partialSetFields }
          })
        }
        else {
          const { insertedId } = await createItem({ collection: 'meeting', payload })
          if (!insertedId) throw new Error('Item not created')
        }
        getExistingDialogue()
      } catch (error) {
        console.log(error)
        handleError({ error, defaultMessage: i18n.t('message.survey_results_fetch_error') })
      } finally {
        isFetchingSurveyResults.value = false
      }
    }

    const validateTab = (tabRef, checkImage = false, checkManualMoodAnswers = false, checkHappiness = false) => new Promise((resolve, reject) => {
      if (checkImage && daily_dialogue_image_required && !imgData.value.fileInfo) reject()
      if (checkManualMoodAnswers && individualResponses.value.length) {
        showErrorMessage(i18n.t('message.individual_responses_pending'))
        reject()
      }
      if (checkHappiness && !happinessReady.value) {
        reject()
        return
      }
      tabRef.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })
    const permissions = ref('')
    const activeButton = ref(showOnlyCustomersOpinions ? 'opinions' : 'communications')
    const handleActiveButton = (val) => {
      activeButton.value = val
    }

    const paginatedCustomersOpinions = computed(() => {
      const start = (currentPage.value - 1) * perPage.value
      const end = start + perPage.value
      return customersOpinions.value.slice(start, end)
    })

    const showConfirmationPage = (route, msg) => {
      confirmationPage.value = { route, msg }
    }

    const getHappinessIcons = async (locationId) => {
      if (!locationId || !isOnline.value) return

      try {
        const query = { _id: oid(locationId) }
        const item = await getItem({ collection: 'location', query })
        if (!item) throw new Error('Item not found')

        useBatteryIcons.value = item.batteryIcons
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.location_fetch_error'))
      }
    }

    const getExistingDialogue = async () => {
      if (!meeting.value.location?.value) return
      const meetingDateZeroHours = formatDatePicker(meeting.value.date);
      meetingDateZeroHours.setHours(0, 0, 0, 0); // Ajustar la hora a 00:00
      const meetingDateNextDay = new Date(meetingDateZeroHours);
      meetingDateNextDay.setDate(meetingDateNextDay.getDate() + 1) // 23:59 del mismo día

      const query = {
        client_id: oid(client_id),
        // created_by: oid(worker_id),
        location: oid(meeting.value.location.value),
        date: { $gte: date(meetingDateZeroHours), $lt: date(meetingDateNextDay) }, // Buscar solo en el día actual
        partial: true,
        // Nunca reutilizar un parcial eliminado: el diálogo se guardaría sobre un documento
        // con deleted: true y no aparecería en ningún tablero
        deleted: { $ne: true }
      }

      if (physical_location_in_daily_dialogue) {
        const physicalLocId = meeting.value?.physical_location?.value
        if (physicalLocId) query.physical_location = oid(physicalLocId)
      } else {
        query.$or = [
          { physical_location: { $exists: false } },
          { physical_location: null },
        ];
      }
      try {
        dailyDialogue.value = await getItem({ collection: 'meeting', query })
      } catch (error) {
        console.log(error)
      }
    }

    // Individual responses (for offline mode)
    const showIndividualModal = ref(false)
    const selectedMood = ref(null) // 'happy' | 'neutral' | 'sad'
    const singleAnswerComment = ref('')
    const responseSent = ref(false)
    const individualResponses = ref([])
    const offlineResponsesCount = computed(() => {
      return individualResponses.value.length
    })

    const openIndividualResponseModal = () => {
      selectedMood.value = null
      singleAnswerComment.value = ''
      responseSent.value = false
      showIndividualModal.value = true
    }

    const submitIndividualResponse = () => {
      individualResponses.value.push({
        answer: selectedMood.value,
        comment: singleAnswerComment.value,
        createdAt: new Date(),
        deviceId: getDeviceId()
      })

      responseSent.value = true
    }

    const getManualResponses = () => {
      individualResponses.value.forEach(r => {
        meeting.value[r.answer] += 1
      })

      comments.value = [...comments.value, ...individualResponses.value]
      individualResponses.value = []
    }

    onMounted(async () => {
      getWorkersTotalForDropDown("notMapped")
      getMotivesForDropDown()
      getSupervisorsForDropDown("onlyNames")
      getMetadataForDropDown({category: "improvement", option: "notMapped"})
      // Wait for both lists before assigning defaults, so the default location is always
      // consistent with the selected physical location regardless of response order
      await Promise.all([getLocationsForDropDown(), getPhysicalLocationsForDropDown()])
      if (userPhysicalLocation) {
        meeting.value.physical_location = filteredPhysicalLocations.value.find(p => p.value === getIdString(userPhysicalLocation.value)) || userPhysicalLocation
      } else if (filteredPhysicalLocations.value.length) {
        meeting.value.physical_location = filteredPhysicalLocations.value[0]
      }
      // Resolve the user's default location against the loaded options valid for the
      // selected physical location; the userData object lacks the physical_location field
      const userLocationId = userLocation ? getIdString(userLocation.value) : null
      meeting.value.location = filteredLocations.value.find(l => l.value === userLocationId) || (filteredLocations.value.length === 1 ? filteredLocations.value[0] : null)
      getHappinessIcons(meeting.value.location?.value)
      if (behaviorFunctionalityDD) fetchSuggestedBehaviour()
    })

    return {
      meeting,
      meetingStart,
      meetingEnd,
      updateImprovements,
      updateRecognitions,
      updateHappiness,
      formSubmitted,
      locations,
      filteredLocations,
      physical_locations,
      filteredPhysicalLocations,
      workersTotalNotMapped,
      motives,
      welcomeTab,
      happinessTab,
      recognitionsTab,
      improvementsTab,
      finishTab,
      validateTab,
      required,
      integer,
      min_value,
      max_value,
      domains,
      uploadImage,
      getImgCompressed,
      compressor,
      imgData,
      metadataNotMapped,
      daily_dialogue_image_required,
      daily_dialogue_date_disabled,
      mood_only_by_survey,
      updateHappinessFromSurvey,
      isFetchingSurveyResults,
      isOnline,
      happyPercentage,
      neutralPercentage,
      sadPercentage,
      happinessReady,
      isHappinessTabActive,
      handleTabChange,
      communications,
      isLoading,
      openImage,
      actualDate,
      actualDateToShow,
      filteredLocation,
      handleActiveButton,
      activeButton,
      customersOpinions,
      permissions,
      information_module,
      sevenDaysBeforeToShow,
      paginatedCustomersOpinions,
      tableColumns,
      sortBy,
      isSortDirDesc,
      opinionId,
      handleView,
      showingMessage,
      perPage,
      currentPage,
      totalOpinions,
      colors,
      showComments,
      comments,
      stateVariants,
      confirmationPage,
      useBatteryIcons,
      batteryIcons,
      dailyDialogue,
      showOnlyCustomersOpinions,
      physical_location_in_daily_dialogue,
      client_id,
      showIndividualModal,
      selectedMood,
      singleAnswerComment,
      responseSent,
      individualResponses,
      offlineResponsesCount,
      openIndividualResponseModal,
      submitIndividualResponse,
      isManualMoodRegistration,
      behaviorFunctionalityDD,
      suggestedBehaviour,
      behaviourImgSrc,
      behaviourImgLoading,
      behaviourLoading,
      fetchSuggestedBehaviour,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.happiness-blocked {
  .wizard-footer-right .wizard-btn {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }
}
</style>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.image-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.hover-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
}

.image-container:hover .hover-text {
  opacity: 1;
}

.img-preview {
  max-width: 200px;
  max-height: 200px;
  margin-right: 10px;
  border: none;
}

.no-image {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(0, 0, 0, 0.7);
  padding: 5px 10px;
  border-radius: 5px;
  opacity: 1;
  transition: opacity 0.3s;
  white-space: nowrap;
  font-size: .9rem;
}

.optionButton {
  background-color: transparent !important;
  color: grey !important;
  border-color: #D8D6DE !important;
}

.optionButton:hover {
  /* border-color: #50b692 !important; */
  border-color: '#4e8769'!important;
  /* color: #50b692 !important; */
  color: #56616d !important;
  /* background-color: rgba(80, 182, 146, 0.1) !important; */
  background-color: #56616d22  !important;
}

.activeClassButton {
  /* background-color: #50b692 !important; */
  background-color: #56616d !important;
  color: white;
  border-color: transparent !important;
}
</style>